<template>
    <span v-for="prop in flatItems" :key="prop.name" class="font-semibold">
        <!-- boolean → show label -->
        <template v-if="prop.type === 'boolean'">
            {{ prop.label }}
        </template>

        <!-- non-boolean → show label + value -->
        <template v-else>{{ prop.label }}: {{ prop.value }}</template>
    </span>
</template>

<script setup>
const { properties } = defineProps({
    properties: {
        type: Array,
        default: () => []
    }
})

// names you want to keep
const allowed = ['count_bedrooms', 'pets_allowed']

const flatItems = computed(() => {
    return properties.flatMap((group) => group.items).filter((item) => allowed.includes(item.name))
})
</script>
